import React from 'react';
import { Col, Row, Form, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndoAlt } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-multiselect/css/bootstrap-multiselect.css'
import './Filter.css';

const Filter = (props) => {
  const {username} = props.criteria;
  
  return (
          <Row>
            {/* <Col sm={2}  className="pr-0">
              <Form.Group controlId="merchantCode">
                <Form.Label className="text-grey font-weight-bold medium">Merchant ID</Form.Label>
                <Form.Control type="text" name="merchantCode" value={merchantCode} onChange={props.onChange} placeholder="Merchant ID" />
              </Form.Group>
            </Col>
            <Col sm={3} className="pr-0">
              <Form.Group controlId="merchantName">
                <Form.Label className="text-grey font-weight-bold medium">Merchant Name</Form.Label>
                <Form.Control type="text" name="merchantName" value={merchantName} onChange={props.onChange} placeholder="Merchant Name" />
              </Form.Group>
            </Col> */}
            <Col sm={3} className="pr-0">
              <Form.Group controlId="username">
                <Form.Label className="text-grey font-weight-bold medium">Username</Form.Label>
                <Form.Control type="text" name="username" value={username} onChange={props.onChange} placeholder="Username" />
              </Form.Group>
            </Col>
            <Col sm={2} className="pr-0">
              <Form.Group controlId="status">
                <Form.Label className="text-grey font-weight-bold medium">Status</Form.Label>
                <Form.Control as="select"
                  name="status"
                  value={props.criteria.status}
                  onChange={props.onChange}>
                  <option value="">All</option>
                  <option value="A">Active</option>
                  <option value="I">Inactive</option>
                  <option value="L">Locked</option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col sm={2} className="pr-0 pl-0 pt-1 mt-4">
              <Button type="button" variant="link" className="link" onClick={props.onSubmit}>
                <FontAwesomeIcon size="lg" icon={faSearch} />
              </Button>
              <Button type="button" variant="link" className="link" onClick={props.onReset}>
                <FontAwesomeIcon size="lg" icon={faUndoAlt} />
              </Button>
            </Col>
          </Row>
  );
}
export default Filter;